import React, {
  PureComponent,
  createRef,
  InputHTMLAttributes,
  RefObject,
  ReactNode,
} from 'react';
import InputMask from 'inputmask';
import TextFieldWrapper from '@mos-cat/text-field-wrapper';
import cn from 'classnames';
import './TextField.pcss';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string | boolean;
  disabled?: boolean;
  autoCapitalize?: any;
  ref?: RefObject<HTMLInputElement>;
}

interface Props {
  key?: any;
  className: string;
  placeholder: string;
  inputProps: InputProps;
  errorLocation?: 'placeholder' | 'tooltip' | 'textBelow';
  maskOptions?: InputMask.Options;
  icon?: ReactNode;
  onClear?: Function;
}

class TextField extends PureComponent<Props> {
  public static defaultProps = {
    className: '',
    errorLocation: 'placeholder',
  };

  private readonly input: RefObject<HTMLInputElement>;

  public constructor(props) {
    super(props);
    this.input = createRef();
  }
  public componentDidUpdate() {
    if (this.input.current) {
      this.input.current.placeholder = '';
    }
  }

  public componentDidMount() {
    const {
      maskOptions = {
        regex: '[А-Яа-яЁё0-9 \\-\\–\\—\\.\\,\\:\\;\\№\\«\\»\\“\\„"\\(\\) ]*',
      },
    } = this.props;

    if (maskOptions && this.input.current) {
      const mask = InputMask(maskOptions);
      mask.mask(this.input.current);
    }
  }

  public render(): JSX.Element {
    const {
      className,
      placeholder,
      inputProps,
      errorLocation,
      onClear,
      icon,
    } = this.props;
    const classes = cn('ym-hide-content', className);

    const { type, value, error, disabled, ...restInputProps } = inputProps;
    return (
      <TextFieldWrapper
        className={classes}
        error={!disabled && error}
        placeholder={placeholder}
        errorLocation={errorLocation}
        icon={icon}
        suffix={icon}
        onClear={onClear}
      >
        <input
          ref={this.input}
          type={type || 'text'}
          value={value || ''}
          disabled={disabled}
          {...restInputProps}
          autoComplete="off"
        />
      </TextFieldWrapper>
    );
  }
}

export default TextField;
